import React from 'react';
import './weatherDetails.css';

/**
 * Skeletons de chargement pour le dashboard Weather Details.
 */
const WeatherDetailsSkeleton = () => (
    <div className="wd-fade-in" aria-busy="true" aria-live="polite" aria-label="Chargement">
        <div className="wd-stats">
            {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="wd-skeleton wd-skeleton-stat" />
            ))}
        </div>
        <div className="wd-skeleton wd-skeleton-table" />
        <div className="wd-skeleton wd-skeleton-table" />
    </div>
);

export default WeatherDetailsSkeleton;
